import React from "react";
import { useSelector } from "react-redux";
import Icon from "../AppIcon";
import CountBadge from "../ui/CountBadge";

// NotificationBell is a visual-only component (no interactive wrapper).
// The interactive trigger is provided by the consuming parent (e.g., Popover.Trigger in NotificationsMenu).
// The count bubble is the shared CountBadge, the same one Pending Actions uses (CO-873).
const NotificationBell = () => {
  const notificationsTotalUnreadCount = useSelector(
    (state: any) => state.notifications.notificationsTotalUnreadCount
  );

  return (
    <CountBadge count={notificationsTotalUnreadCount ?? 0}>
      <Icon name="Bell" size={20} className="text-muted-foreground" />
    </CountBadge>
  );
};

export default NotificationBell;
